<template>
  <section class="section">
    <b-loading v-if="isLoading" :is-full-page="true"/>

    <div v-else class="container">
      <div class="buttons is-right">
        <b-button type="is-primary" :disabled="!hasStock" @click="exportScanStock">
          {{ $t('global.export') }}
        </b-button>
      </div>

      <ag-grid-vue
        style="width: 100%; height: 1000px;"
        class="ag-theme-alpine"
        :modules="modules"
        :pagination="true"
        :pagination-auto-page-size="true"
        :group-display-type="groupDisplayType"
        :grid-options="gridOptions"
        :row-data="stock"
        :column-defs="columnDefs"
      />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { AllModules } from '@ag-grid-enterprise/all-modules'
import XLSX from 'xlsx'
import Enduser from '@/services/v2/enduser'

export default {
  data () {
    return {
      modules: AllModules,
      groupDisplayType: 'custom',
      isLoading: false,
      stock: []
    }
  },
  computed: {
    ...mapState({
      selectedCustomer: state => state.selectedCustomer
    }),
    gridOptions () {
      return {
        autoGroupColumnDef: {
          headerName: this.$t('customer.scan_stock.grid.date')
        }
      }
    },
    columnDefs () {
      return [
        { headerName: this.$t('customer.scan_stock.grid.date'),
          field: 'date',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return params.value.split('T')[0]
          },
          rowGroup: true,
          hide: true
        },
        { headerName: this.$t('customer.scan_stock.grid.barcode'),
          field: 'barcode'
        }
      ]
    },
    hasStock () {
      return !!(this.stock && this.stock.length)
    }
  },
  watch: {
    selectedCustomer: {
      immediate: true,
      handler (newValue, oldValue) {
        if (newValue) {
          this.getStock()
        }
      }
    }
  },
  async mounted () {
  },
  methods: {
    async getStock () {
      if (!this.selectedCustomer) return
      this.isLoading = true
      try {
        const response = await Enduser.getScanStock(this.selectedCustomer)
        this.stock = response || []
      } catch (error) {
        this.$buefy.toast.open({
          message: this.$t('customer.scan_stock.errors.load_data'),
          type: 'is-danger',
          duration: 5000
        })
      } finally {
        this.isLoading = false
      }
    },
    exportScanStock () {
      if (!this.hasStock) return

      const columns = [
        { header: this.$t('customer.scan_stock.grid.date'), field: 'date' },
        { header: this.$t('customer.scan_stock.grid.barcode'), field: 'barcode' }
      ]
      const data = [
        columns.map(column => column.header),
        ...this.stock.map(stock => columns.map(column => this.formatExportValue(stock[column.field], column.field)))
      ]
      const worksheet = XLSX.utils.aoa_to_sheet(data)
      const workbook = XLSX.utils.book_new()
      const fileDate = new Date().toISOString().slice(0, 10)

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Scan stock')
      XLSX.writeFile(workbook, `GPS-${this.$t('sidebar.scan_stock')}-${fileDate}.csv`)
    },
    formatExportValue (value, field) {
      if (!value) return ''
      if (field !== 'date') return value
      return String(value).split('T')[0]
    }
  }
}
</script>
